document.addEventListener("DOMContentLoaded", function() {
    fetch("https://ipinfo.io/json?token=c19930863246af")
        .then(response => response.json())
        .then(data => {
            const countryCode = data.country;
            console.log(window.location.href, countryCode, countryCode === "US" && window.location.href === "https://www.hanselstone.com/")
            if (countryCode === "US" && window.location.href.includes("hanselstone.co.uk")) {
                    window.location.replace("https://hanselstone.com");
                } else if (countryCode === "GB" && window.location.href.includes("hanselstone.com")){
                    window.location.replace("https://hanselstone.co.uk/");
                }
        })
        .catch(error => console.error("Error fetching geolocation:", error));
});
